module.exports = __webpack_public_path__ + "img/clue03.09933b1a.png";